import { Text, View } from '@react-pdf/renderer'

import { styles } from '@/components/StatsExport/components/ListSection/ListSection.config'
import type { ListSectionProps } from '@/components/StatsExport/components/ListSection/ListSection.types'
import { NoData } from '@/components/StatsExport/components/NoData/NoData'

export function ListSection({ data, title }: ListSectionProps) {
  if (!data) return <NoData title={title} />

  return (
    <View style={styles.box} wrap={false}>
      <Text style={styles.title}>{title}</Text>
      {data.length !== 0 ? (
        data.map(value => (
          <View key={value.name} style={styles.textContainer}>
            <View style={[styles.dot, { backgroundColor: value.color }]} />
            <Text style={styles.text}>
              {value.name} - {value.value}
            </Text>
          </View>
        ))
      ) : (
        <Text style={styles.noData}>No data available</Text>
      )}
    </View>
  )
}
